namespace $.$$ {
	export class $bog_bzrl_app_step extends $.$bog_bzrl_app_step {}
	export class $bog_bzrl_app_step_match extends $.$bog_bzrl_app_step_match {}
	export class $bog_bzrl_app_step_request extends $.$bog_bzrl_app_step_request {}
	export class $bog_bzrl_app_step_pay extends $.$bog_bzrl_app_step_pay {}
}
